<script>
    import {onMount} from 'svelte'
    import {authUI} from '../stores'
    import {replace} from 'svelte-spa-router'

    onMount(() => createFirebaseLogin());

    function createFirebaseLogin() {
        if(firebase.auth().currentUser) {
            replace('/equipment');
            return;
        }
        authUI.subscribe(value => {
            if (value === undefined) {
                authUI.set(new firebaseui.auth.AuthUI(firebase.auth()));
            } else {
                value.start('#firebaseui-auth-container', {
                    signInOptions: [
                        {
                            provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                            customParameters: {
                                prompt: 'select_account'
                            }
                        },
                        firebase.auth.EmailAuthProvider.PROVIDER_ID,
                    ],
                    credentialHelper: firebaseui.auth.CredentialHelper.NONE,
                    signInFlow: "popup",
                    signInSuccessUrl: "#/equipment"
                })
            }
        });
    }
</script>

<svelte:head><title>Axces2 - Login</title></svelte:head>

<section id="wrapper">
    <div class="login-register" style="background-image:url(dist/img/login-photo.jpg);">
        <p class="text-center m-b-40">
            <img src="dist/img/logo-axces2-colors.png?v=1.0" class="img-fluid" width="280" id="logo" alt="Axces2">
        </p>
        <div class="login-box card">
            <div class="card-body">
                <form class="form-horizontal form-material" id="loginform" action="templates">
                    <h2 class="box-title m-b-20 text-center">Sign In or Log In</h2>
                    <div id="firebaseui-auth-container"></div>
                </form>
                <form class="form-horizontal" id="recoverform" action="index.html">
                    <div class="form-group ">
                        <div class="col-xs-12">
                            <h3>Recover Password</h3>
                            <p class="text-muted">Enter your Email and instructions will be sent to you! </p>
                        </div>
                    </div>
                    <div class="form-group ">
                        <div class="col-xs-12">
                            <input class="form-control" type="text" required="" placeholder="Email"></div>
                    </div>
                    <div class="form-group text-center m-t-20">
                        <div class="col-xs-12">
                            <button class="btn btn-primary btn-lg btn-block text-uppercase waves-effect waves-light"
                                    type="submit">Reset
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>